import Impersonate from './Impersonate';

export default Impersonate;
